import React from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';
import styles from './HelpButton.module.scss';

const HelpButton = ({ children, size, wide }) => {
	return <Popup size={size} wide={wide} trigger={<span id="helpBtn" className={styles.helpButton}>help</span>}>{children}</Popup>;
};

HelpButton.propTypes = {
	children: PropTypes.any.isRequired,
	size: PropTypes.string,
	wide: PropTypes.bool
};

export default HelpButton;
